import { Icons, Radio, Tooltip, useRadio } from "@texada/ui";
import React, { HTMLProps, MutableRefObject, forwardRef } from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "helpers/helper";
import i18n from "i18n/i18n";

const SWITCH_ITEMS = [
  {
    icon: <Icons.TexadaWeb />,
    name: i18n.t("texada_web"),
    id: "texada-web"
  },
  {
    icon: <Icons.Gateway />,
    name: i18n.t("gateway"),
    id: "gateway"
  },
  {
    icon: <Icons.Settings />,
    name: i18n.t("settings"),
    id: "settings"
  }
];
const TexadaFooterRadio = props => {
  const { checked, RadioLabel, radioProps } = useRadio(props);

  return (
    <Tooltip label={props?.tooltip}>
      <div
        {...(radioProps as any)}
        className={`side_nav_menu-switch-item ${checked ? "active" : ""}`}
      >
        <RadioLabel />
      </div>
    </Tooltip>
  );
};

export interface ISidebarMenuSwitchProps extends HTMLProps<HTMLDivElement> {
  selectedMenu: string;
  setSelectedMenu: React.Dispatch<React.SetStateAction<string>>;
}

const SidebarMenuSwitch = forwardRef(
  (
    { selectedMenu, setSelectedMenu }: ISidebarMenuSwitchProps,
    ref: MutableRefObject<HTMLDivElement>
  ) => {
    const user = useSelector<ReduxState, any>(state => state.auth.user);

    return (user?.enable_gateway && user?.compperms?.gateway_admin) ? (
      <div ref={ref} className="side_nav_menu-switch">
        <Radio.Group
          value={selectedMenu}
          onChange={e => {
            setSelectedMenu(e.target.value);
          }}
        >
          {SWITCH_ITEMS.map(item => (
            <TexadaFooterRadio
              key={item.id}
              value={item.id}
              label={item.icon}
              tooltip={item.name}
            />
          ))}
        </Radio.Group>
      </div>
    ) : null;
  }
);

export default SidebarMenuSwitch;
